import { useQuery } from '@tanstack/react-query';
import { fetchPromotions } from '../../api/sportsbook-api';
import { RefetchInterval, StaleTime } from '../../sportsbook-constants';
import { SPORTSBOOK_QUERY_KEY } from '../queries-constants';
import { PromotionItemDto } from '../../api/sbapi/sbapi-api-model';

type Options<TData> = {
	select?: (data: PromotionItemDto[]) => TData;
	staleTime?: StaleTime;
	refetchInterval?: RefetchInterval;
};

/**
 * Hook for querying promotions
 */
const useQueryPromotions = <TData = PromotionItemDto[]>(options?: Options<TData>) =>
	useQuery({
		queryKey: [SPORTSBOOK_QUERY_KEY, 'promotions'],
		queryFn: fetchPromotions,
		staleTime: options?.staleTime ?? StaleTime.ZERO,
		refetchInterval: options?.refetchInterval,
		select: options?.select,
		meta: {
			errorMessage: `Failed to fetch promotions`
		}
	});

export default useQueryPromotions;
